import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ value, onChange, placeholder = "Search knowledge base..." }) => {
  return (
    <div className="relative">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
        <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
      </div>
      <Input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        className="pl-12 bg-input border-border"
      />
    </div>
  );
};

export default SearchBar;